/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import type { NextBlock } from '@flowus/common/block/type';
import { useFuSelector } from '../store-context/use-fine-context-selector';
import { useIsEnableRedux } from './common';
import type { CommonOptionsType } from './types';
import { useObservableStore } from './use-obs-store';

// #region useObservableBlock
export function useObservableBlock(id?: string): NextBlock | undefined;
export function useObservableBlock<TOutput>(
  id?: string,
  selector?: (b?: NextBlock) => TOutput
): TOutput;
export function useObservableBlock<TOutput>(
  id?: string,
  selector?: (b?: NextBlock) => TOutput,
  dep?: any[]
): TOutput;
export function useObservableBlock<TOutput>(
  id?: string,
  selector?: (b?: NextBlock) => TOutput,
  dep?: any[],
  opt?: CommonOptionsType
): TOutput;
export function useObservableBlock<TOutput>(
  id = '',
  selector?: (b?: NextBlock) => TOutput,
  dep?: any[],
  opt?: CommonOptionsType
) {
  const isEnableRedux = useIsEnableRedux();
  if (isEnableRedux || opt?.useRedux) {
    return useFuSelector((state) => {
      if (selector) {
        return selector(state.blocks[id]);
      }
      return state.blocks[id];
    });
  }

  return useObservableStore(
    (state) => {
      if (selector) {
        return selector(state.blocks[id]);
      }
      return state.blocks[id];
    },
    [id, ...(dep ?? [])],
    opt
  );
}
// #endregion
